// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"444":"abf7813f","505":"9f95fc46","631":"810fa687","835":"91805e66"}[chunkId] + ".chunk.css";
};